import { Checkbox } from "@mui/material";
import CustomTextArea from "@/components/CustomTextArea";
import Flex from "@/components/Flex";
import Text from "@/components/Text";
import { RosAndPe } from "../../encounter-constant";
import HomeCareRosImportList from "../home-care/HomeCareRosImportList";

export interface RosPeImportListProps {
  items: RosAndPe[];
  isHomeCare: boolean;
  onSelect: (index: number) => void;
  onDescriptionChange: (value: string, index: number) => void;
}

const RosPeImportList = ({
  items,
  isHomeCare,
  onSelect,
  onDescriptionChange,
}: RosPeImportListProps) => {
  if (isHomeCare) {
    return (
      <HomeCareRosImportList
        items={items}
        onDescriptionChange={onDescriptionChange}
        onRemove={onSelect}
      />
    );
  }

  return (
    <Flex flexDirection="column" gap={1} width="100%">
      {items.map((item, index) => (
        <Flex key={item.templateNameType ?? index} gap={2} alignItems="start">
          <Checkbox
            checked={item.isSelected}
            onChange={() => onSelect(index)}
          />
          <Flex flexDirection="column" width="100%" mt={1.5}>
            <Text>{item.templateNameType}</Text>
            {item.isSelected && (
              <CustomTextArea
                id="outlined-multiline-static"
                variant="outlined"
                name="desc"
                placeholder="Enter Description"
                value={item.description}
                onChange={(e) => onDescriptionChange(e.target.value, index)}
              />
            )}
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export default RosPeImportList;
